import { assign } from '../Assign';

export default class FormInputChangeHandler {
    private obj: any;
    private callback: (newObj: any) => void;

    constructor(obj: any, callback: (newObj: any) => void) {
        this.obj = assign({}, obj);
        this.callback = callback;

        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public updateObj(newObj: any) {
        this.obj = assign({}, newObj);
    }

    public onChange(e: any) {
        switch (e.target.type) {
            case 'select-one':
                this.handleChange(
                    e.target.name,
                    isNaN(e.target.value) ? e.target.value : parseInt(e.target.value)
                );
                break;
            case 'select-multiple':
                this.handleChange(
                    e.target.name,
                    [...e.target.selectedOptions].map((x) => x.value)
                );
                break;
            case 'checkbox':
            case 'radio':
                this.handleChange(e.target.name, e.target.checked);
                break;
            default:
                this.handleChange(e.target.name, e.target.value);
                break;
        }
    }

    public handleChange(name: string, value: any) {
        this.deepSetValue(this.obj, name, value);
        this.callback(this.obj);
    }

    private deepSetValue(obj: any, path: any, value: any) {
        path = path.split('.');
        for (let i = 0; i < path.length - 1; i++) {
            obj = obj[path[i]];
        }

        obj[path[path.length - 1]] = value;
    }
}
